import { Container } from './PianoInlineTemplateContainerStyles';

const PianoInlineTemplateContainer = () => {
  return (
    <Container
      id='article-piano-template-plea-container'
      key='article-piano-template-plea-container'
    ></Container>
  );
};

export default PianoInlineTemplateContainer;
